import { Editor } from '@tiptap/react';
import { useEffect } from 'react';

type Props = {
  editor: Editor | null;
  progress: number | null;
  urlRef: React.MutableRefObject<string | null>;
  error: string | null;
};

export const useImageProgressEffect = ({
  editor,
  progress,
  urlRef,
  error,
}: Props) => {
  useEffect(() => {
    if (!editor) return;

    if (progress === null) {
      const currentUrl = urlRef.current;
      if (error) {
        queueMicrotask(() => {
          editor
            .chain()
            .deleteImageUploadProgress()
            .setMeta('addToHistory', false)
            .run();
        });
        return;
      }

      if (!currentUrl) return;

      queueMicrotask(() => {
        editor
          .chain()
          .selectImageUploadProgress()
          .setImage({ src: currentUrl })
          .createParagraphNear()
          .setMeta('addToHistory', false)
          .run();
      });

      urlRef.current = null;
      return;
    }

    if (editor.commands.hasImageUploadProgress()) {
      queueMicrotask(() => {
        editor
          .chain()
          .selectImageUploadProgress()
          .updateImageUploadProgress(progress)
          .setMeta('addToHistory', false)
          .run();
      });
    } else {
      queueMicrotask(() => {
        editor.chain().createImageUploadProgress().run();
      });
    }
  }, [editor, progress, urlRef, error]);
};
